module.exports = __webpack_public_path__ + "static/img/print-5.c106a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/print-5.png
// module id = mTro
// module chunks = 10